import React from "react";
//@ts-ignore next line
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { lang } from "../../middleware/lang";

type CancelOrderModalProps = {
  open: boolean;
  toggle: () => void;
  className?: string;
  onConfirm: (restoreInventory: boolean) => void;
};

export const CancelOrderModal: React.FC<CancelOrderModalProps> = ({
  open,
  toggle,
  className,
  onConfirm,
}) => {
  return (
    <Modal isOpen={open} toggle={toggle} className={className} autoFocus={false}>
      <ModalHeader toggle={toggle}>
        {lang("Cancelar Pedido", "Cancel Order")}
      </ModalHeader>
      <ModalBody>
        <p>
          {lang(
            "Este pedido tiene productos con receta. ¿Qué quieres hacer con los ingredientes que ya se descontaron del inventario?",
            "This order has products with a recipe. What do you want to do with the ingredients that were already deducted from inventory?"
          )}
        </p>
      </ModalBody>
      <ModalFooter>
        <button
          onClick={() => onConfirm(true)}
          className="btn btn-success btn-block"
        >
          {lang(
            "Restaurar ingredientes al inventario",
            "Restore ingredients to inventory"
          )}
        </button>
        <small className="text-muted d-block mb-3 px-1">
          {lang(
            "Úsalo si el pedido nunca se preparó.",
            "Use this if the order was never prepared."
          )}
        </small>
        <button
          onClick={() => onConfirm(false)}
          className="btn btn-outline-danger btn-block"
        >
          {lang("Mantener ingredientes descontados", "Keep ingredients deducted")}
        </button>
        <small className="text-muted d-block px-1">
          {lang(
            "Úsalo si el producto ya se preparó y el cliente no se presentó.",
            "Use this if the product was already prepared and the customer didn't show up."
          )}
        </small>
      </ModalFooter>
    </Modal>
  );
};
